package org.gymly.i18n

import androidx.compose.runtime.Composable
import androidx.compose.runtime.ReadOnlyComposable
import androidx.compose.runtime.staticCompositionLocalOf

/** Idiomas soportados por la interfaz. El código coincide con `preferredLocale` del backend. */
enum class GymlyLocale(val code: String) {
    ES("es"),
    EN("en"),
    ;

    companion object {
        /** Tolera "en", "en-US", "EN"… Cualquier valor que no sea inglés cae en español. */
        fun from(value: String?): GymlyLocale =
            if (value?.trim()?.lowercase()?.startsWith("en") == true) EN else ES
    }
}

fun stringsFor(locale: GymlyLocale): GymlyStrings = when (locale) {
    GymlyLocale.ES -> StringsEs
    GymlyLocale.EN -> StringsEn
}

/**
 * Catálogo de textos del idioma activo. Es `static` a propósito: al cambiar de idioma
 * interesa recomponer el árbol completo de una vez, no rastrear lector por lector.
 */
val LocalStrings = staticCompositionLocalOf<GymlyStrings> { StringsEs }

/** Atajo de lectura: `val t = strings()`. */
@Composable
@ReadOnlyComposable
fun strings(): GymlyStrings = LocalStrings.current

/**
 * Elige el catálogo ES/EN según el idioma activo del CompositionLocal.
 * Los módulos (Clientes, Membresías…) lo usan para no repetir el `when`.
 */
@Composable
@ReadOnlyComposable
fun <T> pickStrings(es: T, en: T): T =
    if (LocalStrings.current.locale == GymlyLocale.EN) en else es
